import { Component, OnInit } from '@angular/core';
import {MatDialog} from '@angular/material';
import {Router} from '@angular/router';
import {DialogService} from '../../shared/dialog-service/dialog.service';
import {ContractSelectorService} from '../../shared/contract-selector-service/contract-selector.service';
import {ContractSelectorStateService} from '../../shared/contract-selector-state-service/contract-selector-state.service';
import {TourService} from 'ngx-tour-md-menu';
import {Cedant, Contract, Program} from '../../shared/shared.types';

@Component({
  selector: 'app-cedant-dashboard',
  templateUrl: './cedant-dashboard.component.html',
  styleUrls: ['./cedant-dashboard.component.scss']
})
export class CedantDashboardComponent implements OnInit {

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private ourDialogSrv: DialogService,
    private provider: ContractSelectorService,
    private contractSelectorState: ContractSelectorStateService,
    public tourService: TourService) {
  }

  programs: Program[] = [];

  selectedCedant: Cedant = null;
  selectedProgram: Program = null;
  selectedContract: Contract = null;

  ngOnInit() {
    this.tourService.initialize([{
      anchorId: 'about.help',
      content: 'Welcome to the GRM product tour',
      placement: 'below',
      title: 'Welcome'
    }, {
      anchorId: 'about.selectcedant',
      content: 'About select cedant',
      placement: 'below center',
      title: 'Please select cedant',
    }, {
      anchorId: 'about.addprogram',
      content: 'About add new program',
      title: 'Add new program',
    }, {
      anchorId: 'about.contractselector',
      content: 'You can set custom step button names',
      title: 'Contract Selector'
    }]);

    this.contractSelectorState
      .cedant$.subscribe(c => {
      this.selectedCedant = c;
      if (c) {
        this.selectedProgram = c.programs[0];
      }
    });

    this.contractSelectorState
      .contract$
      .subscribe( c => {
        this.selectedContract = c;
      });
  }
}
